
/**
 * Represents a validation function that performs a boolean check
 * @typedef {Function} ValidationFunction
 * @returns {boolean} True if validation passes, false otherwise
 */
export type ValidationFunction = () => boolean;

/**
 * Validates a list of criteria functions, returning `true` only if all criteria are met.
 * Each function in the `criteriaList` is expected to return a `boolean` indicating
 * whether the criterion is met (`true`) or not (`false`).
 *
 * @param {ValidationFunction[]} criteriaList - An array of functions, each representing a validation criterion.
 * @returns {boolean} - Returns `true` if all criteria pass; otherwise, returns `false`.
 */
export function validateCriteria(criteriaList: ValidationFunction[]): boolean {
    for (const criteria of criteriaList) {
        const result = criteria();
        if (!result) {
            // If any criterion fails, return false immediately
            return false;
        }
    }
    // All criteria passed
    return true;
}